import React from "react";
import {Route, Switch} from "react-router-dom";

// General.
import Login from "../auth/Login/Login";
import {BACKEND_SERVICE_NAME, requiredAuthRoles} from "../../config/generals";
// Users.
import AddEditUser from "../users/AddEditUser/AddEditUser";
import AddEditService from "../services/AddEditService/AddEditService";
import AddEditOrganization from "../organizations/AddEditOrganization/AddEditOrganization";
import {
    ReduxProtectedRoute,
    Alert,
    Grid,
} from "@leap4/frontend";
import {UsersManagementPanel} from "../users/Users/users";
import {ServicesTable} from "../services/Services/services";
import {OrganizationsTable} from "../organizations/organizations/organizations";
import {InternalUsersManagementPanel} from "../users/Users/internalUsers";
import {ExternalUsersManagementPanel} from "../users/Users/externalUsers";

const Routes = () => {

        return (
                <Grid mt={6}>
            {/*<>*/}
                <Alert/>
                <Switch>

                    <Route exact path="/login" component={Login}/>
                    {/*    /!* Redirect to main. *!/*/}
                    <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                         requiredRoles={requiredAuthRoles}
                                         component={UsersManagementPanel} path={"/users"}/>
                    <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                         requiredRoles={requiredAuthRoles}
                                         component={InternalUsersManagementPanel} path={"/users/internal"}/>
                    <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                         requiredRoles={requiredAuthRoles}
                                         component={ExternalUsersManagementPanel} path={"/users/external"}/>

                    <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                         requiredRoles={requiredAuthRoles}
                                         component={AddEditUser} path={'/users/add'}/>
                    <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                         requiredRoles={requiredAuthRoles}
                                         component={AddEditUser} path={'/users/:id'}/>

                    <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                         requiredRoles={requiredAuthRoles} path="/services/add" component={AddEditService}/>
                    <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                         requiredRoles={requiredAuthRoles} path="/services/:id" component={AddEditService}/>

                    <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                         requiredRoles={requiredAuthRoles} path={`/services`}
                                         component={ServicesTable}/>


                    <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                         requiredRoles={requiredAuthRoles} path="/organizations/add"
                                         component={AddEditOrganization}/>

                    <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                         requiredRoles={requiredAuthRoles} path="/organizations/:id"
                                         component={AddEditOrganization}/>

                    <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                         requiredRoles={requiredAuthRoles} path={`/organizations`}
                                         component={OrganizationsTable}/>

                    <Route component={Login}/>
                </Switch>
                 </Grid>
    // </>

        )
    }
;

export default Routes;
